var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard-container" },
    [
      _vm.showWelcomeFlag
        ? _c(
            "div",
            { staticStyle: { "text-align": "center", "margin-top": "20%" } },
            [_c("h1", [_vm._v("Welcome to Merchant Dashboard")])]
          )
        : [
            _vm.$store.getters.isAgentMerchant
              ? _c("DashboardOverviewAgent")
              : _c("div", [_c("dashboard-overview")], 1),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }